function NotificationsPage() {
  return (
    <div className="container" style={{ maxWidth: '700px', margin: '0 auto' }}>
      <div className="card">
        <div className="card-header">Notifications</div>
        <div style={{ padding: '1rem' }}>
          <p style={{ margin: 0, color: '#6b7280' }}>(Coming soon)</p>
        </div>
      </div>
    </div>
  );
}

export default NotificationsPage;
